/* BD Callback time v1.3, 2026-09-24. Alt: fixed daily deadline. Neu: validated shared theme setting, default 17:30. Grund: footer and promises use one source; cutoff/holidays unchanged. */
(function (root, factory) {
  'use strict';
  var api = factory(root);
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else if (root) {
    root.bdCallbackTime = api;
  }
}(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : this), function (root) {
  'use strict';

  var ZONE = 'Europe/Berlin';
  var DAY_MS = 86400000;
  var WEEKDAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var FIXED_HOLIDAYS = ['01-01', '05-01', '10-03', '11-01', '12-25', '12-26'];
  var formatter;

  function dailyDeadline() {
    var setting = '';
    try {
      var element = root && root.document && root.document.querySelector('[data-bd-callback-daily-deadline]');
      setting = element ? element.getAttribute('data-bd-callback-daily-deadline') : '';
    } catch (error) {}
    if (['17:00', '17:30', '18:00'].indexOf(setting) === -1) setting = '17:30';
    var parts = setting.split(':');
    return { hour: Number(parts[0]), minute: Number(parts[1]) };
  }

  function neutral() {
    return {
      title: 'Rückruf anfragen.',
      promise: 'Wir stimmen den Rückruf mit Ihnen ab.',
      buttonLabel: 'Rückruf anfragen',
      successText: 'Wir melden uns telefonisch bei Ihnen.',
      deadlineISO: null,
      dayLabel: ''
    };
  }

  function calendarTime(year, month, day, hour, minute, second) {
    // UTC is only a safe container for calendar arithmetic here, not the operating timezone.
    var date = new Date(0);
    date.setUTCFullYear(year, month - 1, day);
    date.setUTCHours(hour || 0, minute || 0, second || 0, 0);
    return date.getTime();
  }

  function berlinParts(date) {
    if (!formatter) {
      if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') {
        throw new Error('Timezone formatting unavailable');
      }
      var candidateFormatter = new Intl.DateTimeFormat('en-GB-u-ca-gregory-nu-latn', {
        timeZone: ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });
      if (typeof candidateFormatter.formatToParts !== 'function' || candidateFormatter.resolvedOptions().timeZone !== ZONE) {
        throw new Error('Berlin timezone unavailable');
      }
      formatter = candidateFormatter;
    }
    var parts = {};
    formatter.formatToParts(date).forEach(function (part) {
      if (part.type !== 'literal') parts[part.type] = Number(part.value);
    });
    var keys = ['year', 'month', 'day', 'hour', 'minute', 'second'];
    if (!keys.every(function (key) { return Number.isFinite(parts[key]); }) ||
        parts.year < 1583 || parts.year > 9998 || parts.month < 1 || parts.month > 12 ||
        parts.day < 1 || parts.day > 31 || parts.hour < 0 || parts.hour > 23 ||
        parts.minute < 0 || parts.minute > 59 || parts.second < 0 || parts.second > 59) {
      throw new Error('Invalid calendar parts');
    }
    return parts;
  }

  function nextDate(day, offset) {
    var result = new Date(calendarTime(day.year, day.month, day.day) + offset * DAY_MS);
    return { year: result.getUTCFullYear(), month: result.getUTCMonth() + 1, day: result.getUTCDate() };
  }

  function dayKey(day) {
    return (day.month < 10 ? '0' : '') + day.month + '-' + (day.day < 10 ? '0' : '') + day.day;
  }

  function sameDay(a, b) {
    return a.year === b.year && a.month === b.month && a.day === b.day;
  }

  function easterSunday(year) {
    // Gregorian Meeus/Jones/Butcher algorithm; no device-local date operations.
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var value = h + l - 7 * m + 114;
    return { year: year, month: Math.floor(value / 31), day: value % 31 + 1 };
  }

  function isWorkingDay(day) {
    var weekday = new Date(calendarTime(day.year, day.month, day.day)).getUTCDay();
    if (weekday === 0 || weekday === 6 || FIXED_HOLIDAYS.indexOf(dayKey(day)) !== -1) return false;
    var easter = easterSunday(day.year);
    // NRW: Good Friday, Easter Monday, Ascension, Whit Monday, Corpus Christi.
    return ![-2, 1, 39, 50, 60].some(function (offset) {
      return sameDay(day, nextDate(easter, offset));
    });
  }

  function deadlineISO(day, hour, minute) {
    var wallTime = calendarTime(day.year, day.month, day.day, hour, minute);
    var candidate = wallTime;
    // Resolve the offset on the target day, including DST changes between request and callback.
    for (var attempt = 0; attempt < 4; attempt += 1) {
      var actual = berlinParts(new Date(candidate));
      if (sameDay(day, actual) && actual.hour === hour && actual.minute === minute && actual.second === 0) {
        return new Date(candidate).toISOString();
      }
      candidate += wallTime - calendarTime(actual.year, actual.month, actual.day, actual.hour, actual.minute, actual.second);
    }
    throw new Error('Could not resolve callback deadline');
  }

  function describe(date) {
    try {
      var input = date === undefined ? new Date() : date;
      var timestamp = Date.prototype.getTime.call(input);
      if (!Number.isFinite(timestamp)) return neutral();
      var instant = new Date(timestamp);
      var today = berlinParts(instant);
      var target = { year: today.year, month: today.month, day: today.day };
      var seconds = today.hour * 3600 + today.minute * 60 + today.second;
      // Exact cutoff: 16:30:00.000 is included; 16:30:00.001 and later use the next workday.
      var cutoff = 16 * 3600 + 30 * 60;
      var withinCutoff = seconds < cutoff || (seconds === cutoff && instant.getUTCMilliseconds() === 0);
      var hour = 10;
      var minute = 0;

      if (isWorkingDay(today) && withinCutoff) {
        // Existing early-morning behavior is retained; the daily deadline comes from the shared theme setting.
        var daily = dailyDeadline();
        hour = daily.hour;
        minute = daily.minute;
      } else {
        var found = false;
        for (var offset = 1; offset <= 14; offset += 1) {
          target = nextDate(today, offset);
          if (isWorkingDay(target)) {
            found = true;
            break;
          }
        }
        if (!found) return neutral();
      }

      var dayLabel = sameDay(today, target) ? 'heute' :
        (sameDay(nextDate(today, 1), target) ? 'morgen' : WEEKDAYS[new Date(calendarTime(target.year, target.month, target.day)).getUTCDay()]);
      var phrasing = dayLabel === 'heute' || dayLabel === 'morgen' ? dayLabel : 'am ' + dayLabel;
      var timeLabel = hour + ':' + (minute < 10 ? '0' : '') + minute;
      var successText = 'Wir rufen Sie ' + phrasing + ' bis ' + timeLabel + ' Uhr zurück.';
      return {
        title: 'Wir rufen Sie ' + phrasing + ' zurück.',
        promise: dayLabel === 'heute' ? 'Bis 16:30 Uhr eintragen – Rückruf heute bis ' + timeLabel + ' Uhr.' : successText,
        buttonLabel: 'Rückruf ' + dayLabel,
        successText: successText,
        deadlineISO: deadlineISO(target, hour, minute),
        dayLabel: dayLabel
      };
    } catch (error) {
      return neutral();
    }
  }

  return { describe: describe };
}));
